import type { GetStaticPaths, GetStaticProps } from "next";
import { seoPages } from "@/generated/seo-metadata";
import { seoContentBySlug } from "@/generated/seo-registry";
import type { SeoPageMetadata } from "@/lib/seo-content-types";
import { seoMdxComponents } from "@/components/seo/seo-content-components";
import { SeoPageTemplate } from "@/components/seo/seo-page-template";

export default function SeoResourcePage({
  metadata,
}: {
  metadata: SeoPageMetadata;
}) {
  const Content = seoContentBySlug[metadata.slug];
  if (!Content) throw new Error(`Missing SEO content for ${metadata.slug}`);

  return (
    <SeoPageTemplate key={metadata.slug} metadata={metadata}>
      <Content components={seoMdxComponents} />
    </SeoPageTemplate>
  );
}

export const getStaticPaths: GetStaticPaths = async () => {
  const pages =
    process.env.NODE_ENV === "production"
      ? seoPages.filter((page) => page.status === "published")
      : seoPages;

  return {
    fallback: false,
    paths: pages.map((page) => ({ params: { slug: page.slug } })),
  };
};

export const getStaticProps: GetStaticProps<{
  metadata: SeoPageMetadata;
}> = async ({ params }) => {
  const slug = typeof params?.slug === "string" ? params.slug : "";
  const metadata = seoPages.find((page) => page.slug === slug);

  if (
    !metadata ||
    (process.env.NODE_ENV === "production" && metadata.status !== "published")
  ) {
    return { notFound: true };
  }

  return { props: { metadata } };
};
